/**
 * Moduł odpowiedzialny za bloczek użytkownika w nagłówku, udostępnia informacje o użytkowniku. Dopiero po załadowaniu bloczka doczytywany jest tryb operatorski i dolna belka
 * @type {module}
 */

app.service('account',function($global, callback, html, front, loading, localStorage, modal, simpleToastr, pageConfig, broker, message) {
	var $self = false;
	var $showUserMenu, $favoriteBox, $showUserFavoriteMenu;
	var isLoad=false;
	var onLoadCallbacks=[];
	const USER_MENU_SHOW_CLASS = 'show-account-menu';
	const FAVORITE_MENU_SHOW_CLASS = 'show-favorite-box-menu';

	var user = {}; // informacje zwrócone z ajaxa
	var isInit = false;

	function showMessageForFrontUser(message) {
		modal.alert(message);
	}
	function checkUserNotifications() {
		if (user.activeInstalmentOrdersCount) {
			const notificationCount = user.activeInstalmentOrdersCount;
			$('.js-user-notifications-count', $self).attr('aria-label', `Masz ${notificationCount} nowych powiadomień`).text(`${notificationCount}`);
		}
		if (user.customerMenuItemsLabels && user.customerMenuItemsLabels.length > 0) {
			user.customerMenuItemsLabels.forEach(function (item) {
				$(`#account-menu .account-menu-link[data-label-id="${item.id}"] .js-account-menu-notification-label`).attr('title', `${item.label}`).text(`${item.label}`);
			});
		}
	}
	function getInfo() {
		if(front.katalog){
			var wc=pageConfig.getData('wc');
			return $.extend(true, {
				wcEmail:wc.email
			}, user);
		}else{
			return $.extend(true, {}, user);
		}
	}
	function setUserWatchedProductsCount(data){
		const watchedProductsCount = data && data.customerWatchedProductsCount || 0;
		const savedComparisionsCount = data && data.customerComparisonsCount || 0;
		const clipboardCount = watchedProductsCount + savedComparisionsCount;
		if (data && data.frontUserLogged === true) {
			$('.js-clipboard-products-count').text(clipboardCount > 0 ? clipboardCount: ''); // Aktualizacja licznika głównego ulubionych dla KK
			$('.js-header-watched-products-count', $favoriteBox).text(watchedProductsCount); // Aktualizacja licznika obserwowanych produktów
			$('.js-header-saved-comparisons-count', $favoriteBox).text(savedComparisionsCount); // Aktualizacja licznika zapisanych porównań
		} else {
			// TODO: EUROMO-7331 pobrać dane z localStorage od Headless
			$('.js-clipboard-products-count').text(''); // Aktualizacja licznika głównego ulubionych dla niezalogowanego użytkownika
		}
	}
	function userLoggedSuccess(data) {
		user = data;
		setUserWatchedProductsCount(data)
		html.remove('user-not-logged user-logged');
		if (data.frontUserLogged === true) {
			html.add('user-logged');
			$('.js-user-name').text(data.firstname);
			// $('.js-user-email').text(data.email); //do weryfikacji
			showLoginUserConfirmMessage();
		} else {
			html.add('user-not-logged');
			setBackToUrl();
		}
		permissionToProcessing = data.permissionToProcessing; // do
		// weryfikacji
		permissionToAccessForCooperatingEntities = data.permissionToAccessForCooperatingEntities; // do
		// weryfikacji
		permissionToElectronicChannel = data.permissionToElectronicChannel; // do
		// weryfikacji

		if (data.showMessageForFrontUser === true) {
			showMessageForFrontUser(data.messageForFrontUser);
		}
		checkUserNotifications();
		urlWhichEnforcesLogin = (typeof data.urlWhichEnforcesLogin !== "undefined") ? data.urlWhichEnforcesLogin
				: ""; // do weryfikacji
		onLoadInit(data);
	}
	function onLoadInit(data){
		isLoad=true;
		callback.run('USER_DATA', $.extend({},data));
		for(var i=0;i<onLoadCallbacks.length;i++){
			var call=onLoadCallbacks[i];
			call($.extend({},data));
		}
	}
	function getUserData() {
		if ($self.length) {
			var params = $.parseQuery(); // do przeniesienia
			//var searchData = getSearchData(); // do przeniesienia

			$.ajax({
				url : '/userData.ltr',
				dataType : 'json',
				cache : false,
				data : {
					from : params.from,
					lastViewedProductId : front.getParam('lastViewedProductId')
				},
				success : function(data, status, xhr) {
					broker.trigger('DATETIME_ONLOAD', [xhr.getResponseHeader('Date')]);
					userLoggedSuccess(data);
				},
				error : function(xhr, err) {
					broker.trigger('DATETIME_ONLOAD', [xhr.getResponseHeader('Date')]);
					onLoadInit(false);
					if (xhr.status == 503) {
						callback.run('get503Page');
					}
				}
			});
		}else{
			onLoadInit(false);
		}
	}

	function setElements(){
		if(localStorage.getItem('watched-products-list-permissions-minimalize')){// warunek do usunięcia po jakimś czasie od wdrozenia zadania
			localStorage.setItem('permissions-minimalize', true);
			localStorage.removeItem('watched-products-list-permissions-minimalize');
		}
		$self = $('#account-box');
		$showUserMenu = $self.find('.js-show-user-menu');
		$favoriteBox = $('#favorite-box');
		$showUserFavoriteMenu = $favoriteBox.find('.js-show-user-favorite-menu');
	}
	function show($button, className){
		html.add(className);
		$button.attr('aria-expanded', 'true');
	}
	function hide($button, className){
		html.remove(className);
		$button.attr('aria-expanded', 'false');
	}
	function isShow(className){
		return html.has(className);
	}
	function toggleSubmenu($button, className){
		isShow(className) ? hide($button, className) : show($button, className);
	}

	function getCurrentPagePathWithParams() {
		return window.location.pathname + window.location.search;
	}
	function isPageExcludedFromRedirectBack(backToPath) {
		return backToPath.indexOf('.bhtml') === -1 || backToPath.indexOf('account-login.bhtml') === 1 || backToPath.indexOf('moje-konto.bhtml') === 1 || front.page() === 'error404' || front.page() === 'error403';
	}
	function resolveBackToPath(currentPage) {
		return currentPage.indexOf('/guest-') !== -1 ? '/' : currentPage;
	}
	function setBackToUrl() {
		const currentPage = getCurrentPagePathWithParams();
		if (!isPageExcludedFromRedirectBack(currentPage)) {
			const backToPath = encodeURIComponent(resolveBackToPath(currentPage));
			$('.js-back-to-page-after-login').attr('href', '/account-auth.bhtml?backTo=' + backToPath);
		}
	}
	function showLoginUserConfirmMessage() {
		const pagePathBeforeLogin = localStorage.getItem('pageBeforeLogin');
		const currentPagePathWithParams = getCurrentPagePathWithParams();
		if (pagePathBeforeLogin == currentPagePathWithParams) {
			message.get('customer-success-login-header-popup-message').then(function (messageValue) {
				const $message = $('<div role="alert" id="after-login-message" aria-live="assertive" aria-atomic="true" />');
				$('body').prepend($message);
				$('#after-login-message').html(messageValue); // potrzebujemy poźniejszego dodania treści, aby czytnik na niego zareagował
			});
			localStorage.removeItem('pageBeforeLogin');
		}
	}

	function setEvents(){
		$showUserMenu.on('click', function(event){
			event.preventDefault();
			toggleSubmenu($showUserMenu, USER_MENU_SHOW_CLASS);
		});
		$showUserFavoriteMenu.on('click', function(event){
			event.preventDefault();
			toggleSubmenu($showUserFavoriteMenu, FAVORITE_MENU_SHOW_CLASS);
		});
		$('body').on('click', function(event){
			if(isShow(USER_MENU_SHOW_CLASS) && !$(event.target).closest('#account-box').length) {
				hide($showUserMenu, USER_MENU_SHOW_CLASS);
			}
			if(isShow(FAVORITE_MENU_SHOW_CLASS) && !$(event.target).closest('#favorite-box').length) {
				hide($showUserFavoriteMenu, FAVORITE_MENU_SHOW_CLASS);
			}
		}).on('click', '.js-back-to-page-after-login', function(e) {
			localStorage.setItem('pageBeforeLogin', getCurrentPagePathWithParams());
		}).on('keyup', function(e) {
			if (e.key === 'Escape') {
				if (isShow(USER_MENU_SHOW_CLASS)) {
					hide($showUserMenu, USER_MENU_SHOW_CLASS);
					$showUserMenu.focus();
				}
				if (isShow(FAVORITE_MENU_SHOW_CLASS)) {
					hide($showUserFavoriteMenu, FAVORITE_MENU_SHOW_CLASS);
					$showUserFavoriteMenu.focus();
				}
			}
		}).on('focusin', function(e) {
			// zamknięcie menu użytkownika po wyjściu tabulatorem obszaru aktywnego menu
			if(!$(e.target).closest('#account-box').length) {
				hide($showUserMenu, USER_MENU_SHOW_CLASS);
			}
			// zamknięcie menu ulubionych po wyjściu tabulatorem obszaru aktywnego menu
			if(!$(e.target).closest('#favorite-box').length) {
				hide($showUserFavoriteMenu, FAVORITE_MENU_SHOW_CLASS);
			}
		});
	}
	function onLoad(callback){
		if(isLoad){
			callback();
		}else{
			onLoadCallbacks.push(callback);
		}
	}
	function init() {
		if (!isInit) {
			setElements();
			setEvents();
			simpleToastr.init();
			if(front.katalog){
				onLoadInit({});
			}else{
				getUserData();
			}
			isInit = true;
		}
	}


	function isFrontUserLogged() {
		var returnValue = false;
		loading.start();
		$.ajax({
			url: '/front-user-logged.ltr',
			dataType: 'json',
			async: false,
			success: function success(data) {
				loading.stop();
				if (data.logged) {
					returnValue = true;
				}
			}, error: function () { 
				loading.stop();
			}
		});
		return returnValue;
	}


	$global('userDataReload',getUserData);
	$global('loggedUserInfo',getInfo);
	return {
		init : init,
		user : getInfo,
		reload: getUserData,
		isLoad : function(){
			return isLoad===true;
		},
		onLoad: onLoad,
		isFrontUserLogged: isFrontUserLogged
	};
});
